// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../Assets/Images/blue-bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../Assets/Images/zap.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../Assets/Images/white-check.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../Assets/Images/dark-check.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.react-toggle-track {
  background-color: #3e90f0 !important;
}

.react-toggle-track:hover {
  background-color: #0d6efd !important;
}

.react-toggle--checked .react-toggle-track {
  background-color: #3EDD78 !important;
}

.react-toggle--checked:hover:not(.react-toggle--disabled) .react-toggle-track {
  background-color: #3EDD78 !important;
}

.monthly-text {
  font-family: Inter;
  font-weight: 700;
  padding-right: 10px;
}

.yearly-text {
  font-family: Inter;
  font-weight: 700;
  padding-left: 10px;
}

.mobile-plan-title {
  color: #141718;
  text-align: center;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: -0.32px;
  width: 90%;
  margin: 0 auto;
}

.logo-subscription {
  margin-top: 20px;
  margin-bottom: 20px;
}

.mobile-plan-top {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center top;
}

.modile-plan-header p {
  color: #141718;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-top: 20px;
}

.modile-plan-header p span {
  background: linear-gradient(90deg, #23C65E 0%, #0084FF 100%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-size: 17px;
  font-weight: 600;
}

.yearly-text small {
  background-color: #141718;
  font-size: 10px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  color: #ffffff;
  border-radius: 4px;
  padding: 2px 6px;
  margin-left: 4px;
}

.plan-container .plan-option.best-option h4 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-repeat: no-repeat;
  padding-left: 24px;
}

.plans-row {
  display: flex;
  flex-direction: column-reverse;
}

.plan-container .plan-option .popular-opt {
  border-radius: 25px;
  background-color: #FF69B4;
}

.plan-container .plan-option .plan-description {
  display: none;
}

.plans-row .plan-option.best-option .plan-opt span {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) !important;
  width: 24px;
  height: 24px;
  padding: 10px;
}

.plans-row .plan-option .plan-opt span {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) !important;
  width: 24px;
  height: 24px;
  padding: 10px;
}

.plan-container .plan-option h2 .plan-fullprice {
  height: unset;
}

.table-header {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  align-content: center;
}

.table-header h6 {
  margin: 0;
  font-size: 16px;
  font-weight: 500;
  margin-left: 6px;
}

.features-list .list-header {
  list-style: none;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-left: 0;
  width: 100%;
  padding-bottom: 20px;
  border-bottom: solid 1px #d0d0d0;
}

.features-list .head {
  min-width: 220px;
  text-align: left;
}

.features-list .type {
  min-width: 50px;
  text-align: center;
  justify-content: center;
  flex-direction: row;
  display: flex;
  font-weight: 600;
}

.features-list .type.special {
  color: #23C65E;
}

.features-list .check {
  min-width: 50px;
  text-align: center;
  justify-content: center;
  flex-direction: row;
  display: flex;
}

.features-list .list-item {
  list-style: none;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-left: 0;
  width: 100%;
  padding-bottom: 14px;
}

.features-list .head {
  min-width: 220px;
  text-align: left;
}

.features-list .check {
  min-width: 50px;
  text-align: center;
  justify-content: center;
  flex-direction: row;
  display: flex;
}`, "",{"version":3,"sources":["webpack://./src/Components/SelectPlanMobile/selectplanmobile.scss"],"names":[],"mappings":"AAAA;EACE,oCAAA;AACF;;AAEA;EACE,oCAAA;AACF;;AAEA;EACE,oCAAA;AACF;;AAEA;EACE,oCAAA;AACF;;AAEA;EACE,kBAAA;EACA,gBAAA;EACA,mBAAA;AACF;;AAEA;EACE,kBAAA;EACA,gBAAA;EACA,kBAAA;AACF;;AAEA;EACE,cAAA;EACF,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,cAAA;AACA;;AAEA;EACE,gBAAA;EACA,mBAAA;AACF;;AAEA;EACE,yDAAA;EACA,4BAAA;EACA,wBAAA;EACA,+BAAA;AACF;;AAEA;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;AACF;;AAEA;EACE,4DAAA;EACA,qBAAA;EACA,6BAAA;EACA,oCAAA;EACA,eAAA;EACA,gBAAA;AACF;;AAEA;EACE,yBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;AACF;;AAEA;EACE,yDAAA;EACA,4BAAA;EACA,kBAAA;AACF;;AAEA;EACE,aAAA;EACA,8BAAA;AACF;;AAEA;EACE,mBAAA;EACA,yBAAA;AACF;;AAEA;EACE,aAAA;AACF;;AAEA;EACE,oEAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;AACF;;AAEA;EACE,oEAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;AACF;;AAEA;EACE,aAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,mBAAA;EACA,qBAAA;AACF;;AAEA;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AACF;;AAEA;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,oBAAA;EACA,gCAAA;AACF;;AAEA;EACC,gBAAA;EACA,gBAAA;AACD;;AACA;EACE,eAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,gBAAA;AAEF;;AACA;EACE,cAAA;AAEF;;AACA;EACE,eAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;AAEF;;AAGA;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,oBAAA;AAAF;;AAGA;EACC,gBAAA;EACA,gBAAA;AAAD;;AAGA;EACE,eAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;AAAF","sourcesContent":[".react-toggle-track {\n  background-color: #3e90f0 !important;\n}\n\n.react-toggle-track:hover {\n  background-color: #0d6efd !important;\n}\n\n.react-toggle--checked .react-toggle-track {\n  background-color: #3EDD78 !important;\n}\n\n.react-toggle--checked:hover:not(.react-toggle--disabled) .react-toggle-track {\n  background-color: #3EDD78 !important;\n}\n\n.monthly-text {\n  font-family: Inter;\n  font-weight: 700;\n  padding-right: 10px;\n}\n\n.yearly-text {\n  font-family: Inter;\n  font-weight: 700;\n  padding-left: 10px;\n}\n\n.mobile-plan-title{\n  color: #141718;\ntext-align: center;\nfont-size: 20px;\nfont-style: normal;\nfont-weight: 600;\nline-height: normal;\nletter-spacing: -0.32px;\nwidth: 90%;\nmargin: 0 auto;\n}\n\n.logo-subscription{\n  margin-top: 20px;\n  margin-bottom: 20px;\n}\n\n.mobile-plan-top{\n  background-image: url(\"../../Assets/Images/blue-bg.png\");\n  background-repeat: no-repeat;\n  background-size: contain;\n  background-position: center top;\n}\n\n.modile-plan-header p{\n  color: #141718;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n  margin-top: 20px;\n}\n\n.modile-plan-header p span{\n  background: linear-gradient(90deg, #23C65E 0%, #0084FF 100%);\n  background-clip: text;\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  font-size: 17px; \n  font-weight: 600;\n}\n\n.yearly-text small{\n  background-color: #141718;\n  font-size: 10px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n  color: #ffffff;\n  border-radius: 4px;\n  padding: 2px 6px;\n  margin-left: 4px;\n}\n\n.plan-container .plan-option.best-option h4{\n  background-image: url(\"../../Assets/Images/zap.svg\");\n  background-repeat: no-repeat;\n  padding-left: 24px;\n}\n\n.plans-row {\n  display: flex;\n  flex-direction: column-reverse;\n}\n\n.plan-container .plan-option .popular-opt{\n  border-radius: 25px;\n  background-color: #FF69B4;\n}\n\n.plan-container .plan-option .plan-description{\n  display: none;\n}\n\n.plans-row .plan-option.best-option .plan-opt span{\n  background-image: url(\"../../Assets/Images/white-check.svg\") !important;\n  width: 24px;\n  height: 24px;\n  padding: 10px;\n}\n\n.plans-row .plan-option .plan-opt span{\n  background-image: url(\"../../Assets/Images/dark-check.svg\") !important;\n  width: 24px;\n  height: 24px;\n  padding: 10px;\n}\n\n.plan-container .plan-option h2 .plan-fullprice{\n  height: unset;\n}\n\n.table-header{\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  align-items: center;\n  align-content: center;\n}\n\n.table-header h6{\n  margin: 0;\n  font-size: 16px;\n  font-weight: 500;\n  margin-left: 6px;\n}\n\n.features-list .list-header{\n  list-style: none;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding-left: 0;\n  width: 100%;\n  padding-bottom: 20px;\n  border-bottom: solid 1px #d0d0d0;\n}\n\n.features-list .head{\n min-width: 220px;\n text-align: left;\n}\n.features-list .type{\n  min-width:50px;\n  text-align: center;\n  justify-content: center;\n  flex-direction: row;\n  display: flex;\n  font-weight: 600;\n}\n\n.features-list .type.special{\n  color: #23C65E;\n}\n\n.features-list .check{\n  min-width:50px;\n  text-align: center;\n  justify-content: center;\n  flex-direction: row;\n  display: flex;\n}\n\n\n\n.features-list .list-item{\n  list-style: none;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding-left: 0;\n  width: 100%;\n  padding-bottom: 14px;\n}\n\n.features-list .head{\n min-width: 220px;\n text-align: left;\n}\n\n.features-list .check{\n  min-width:50px;\n  text-align: center;\n  justify-content: center;\n  flex-direction: row;\n  display: flex;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
